import dayjs from 'dayjs';

export const fmtDate = (v?: string | Date | null, fallback = '—') => (v ? dayjs(v).format('MMM D, YYYY') : fallback);
export const fmtDateTime = (v?: string | Date | null, fallback = '—') => (v ? dayjs(v).format('MMM D, YYYY h:mm A') : fallback);
export const fmtShortDate = (v?: string | Date | null, fallback = '—') => (v ? dayjs(v).format('MMM D') : fallback);

export const PRIORITY_COLORS: Record<string, string> = {
  low: '#12B76A',
  medium: '#F59E0B',
  high: '#F97316',
  urgent: '#EF4444',
};

export const PROJECT_STATUS_META: Record<string, { label: string; color: string }> = {
  planning: { label: 'Planning', color: '#6226A7' },
  on_track: { label: 'On track', color: '#12B76A' },
  at_risk: { label: 'At risk', color: '#F59E0B' },
  on_hold: { label: 'On hold', color: '#98A2B3' },
  completed: { label: 'Completed', color: '#0EA5E9' },
};

export const PROJECT_COLORS = ['#6226A7', '#A855F7', '#F6A938', '#EC4899', '#0EA5E9', '#12B76A', '#EF4444', '#546E7A'];

/** The API returns Mongo documents with either `id` or `_id`. */
export const idOf = (x?: { id?: string; _id?: string } | null) => (x ? x.id || x._id || '' : '');

export const initials = (name = '?') =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('') || '?';

/** Strips scripts, iframes, inline handlers and javascript: URLs from user-authored rich text before rendering it. */
export function sanitizeHtml(html: string): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script,style,iframe,object,embed,link,meta').forEach((n) => n.remove());
  doc.querySelectorAll('*').forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value.trim().toLowerCase();
      if (name.startsWith('on') || ((name === 'href' || name === 'src') && /^java\s*script:/.test(value))) el.removeAttribute(attr.name);
    });
  });
  return doc.body.innerHTML;
}

export const htmlToPlain = (html?: string) => (html ? new DOMParser().parseFromString(html, 'text/html').body.textContent || '' : '');
